import React, {Component} from "react";
import PropTypes from 'prop-types';
import _ from "lodash";
import {NavLink} from "react-router-dom";

const propTypes = {
	icon: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	actions: PropTypes.array,
	stateNav: PropTypes.bool,
	type: PropTypes.string,
	entity: PropTypes.string,
	changeStates: PropTypes.func,
	changeMuns: PropTypes.func
}

class SubCdmNavigation extends Component {
	render() {
		let { icon, name, actions, stateNav, agenciable } = this.props;
		let states = this.stateList();
		let municipalities = this.municipalityList();
		return (<div className="subnavigation">
				<div className="level">
					<div className="level-item">
						<div className="subnav-section">
							<i className={`fa ${icon} has-text-inm-dark-purple`} />
							<p>{name}</p>
						</div>
					</div>

					{actions && _.map(actions, (slot, key) => {
						let item = this.subnavbarItem(slot);
						return <div className="level-item" key={`subnav-${key}`}>
							{item}
						</div>})
					}

					{(stateNav && stateNav === true) &&
					<div className="level-item subnav-states">
						<div className="field has-addons">
                            <div className="field has-addons">
                                <div className="control">
                                    <div className="select is-small is-dark">
                                        <select ref="stateNav-statesMun" value={agenciable.state} onChange={(field) => this.props.changeStates(field.target.value)}>
                                            <option value="">--- Estado ---</option>
                                            {_.map(states, (st, key) => {
                                                return <option value={st.agenciable_state_short} key={key}>{st.agenciable_state_name}</option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="control">
                                    <div className="select is-small is-dark">
                                        <select ref="stateNav-muns" onChange={(e) => this.props.changeMuns(agenciable.state,e.target.value)} value={agenciable.municipality}>
                                            <option value="">--- Municipios ---</option>
                                            {_.map(municipalities, (mun, j) => {
                                                return <option value={mun.agenciable_slug} key={j}>{mun.agenciable_name}</option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
						</div>
					</div>}
				</div>
			</div>);
	}

	subnavbarItem(item) {
		switch(item.type) {
			case 'button':
				return (<div className="subnav-actions">
					<p>
						<NavLink to={item.url} className="button is-small is-inm-purple">{item.name}</NavLink>
					</p>
				</div>)
			case 'search':
				return (<div className="subnav-actions">
					{item.element}
				</div>)
			case 'element':
				return (<div className="subnav-actions">
					{item.element}
				</div>)
			default:
				return (<div className="subnav-actions">
					<p>
						{item.name}
					</p>
				</div>)
		}
	}

	stateList(){
		const { cdms } = this.props;

        return _.sortBy(_.uniqBy(cdms,'agenciable_state_id'), ['agenciable_state_name']);
	}

	municipalityList(){
		const {cdms, agenciable} = this.props;

		return _.sortBy(_.filter(cdms, {agenciable_state_short: agenciable.state}), ['agenciable_name'])
	}
}

SubCdmNavigation.propTypes = propTypes;

export default SubCdmNavigation;



// WEBPACK FOOTER //
// ./src/elements/navigation/subnavigation-cdms.jsx